import { FieldValues } from "react-hook-form";
import withDraggable from "hocs/withDraggable";
import FieldsItem from "./Item";
import { FieldsListItemProps } from "./types";

const FieldsItemWithDraggable = withDraggable(FieldsItem);

interface FieldsListProps<TFieldValues extends FieldValues = FieldValues> extends FieldsListItemProps<TFieldValues> {
  keyName: string;
}

const FieldsList = <TFieldValues extends FieldValues = FieldValues>({
  fields,
  keyName,
  withDragNDrop = false,
  ...rest
}: FieldsListProps<TFieldValues>) => {
  return fields.map((field, index) => {
    const fieldsItemBaseProps = {
      fields,
      index,
    };

    return withDragNDrop ? (
      // @ts-expect-error проблема типизации из-за хока withDraggable
      <FieldsItemWithDraggable
        key={field[keyName]}
        draggableId={field[keyName]}
        {...fieldsItemBaseProps}
        {...rest}
      />
    ) : (
      <FieldsItem
        key={field[keyName]}
        {...fieldsItemBaseProps}
        {...rest}
      />
    );
  });
};

export default FieldsList;
